"use client"

import { Env } from "@/env.mjs"
import Script from "next/script"
import type { FC } from "react"

export const LeadbackWidget: FC = () => {
    return (
        <Script id="leadback-widget" strategy="afterInteractive">
            {`
                var _emv = _emv || [];
                _emv['campaign'] = '${Env.NEXT_PUBLIC_LEADBACK_CAMPAIGN}';

                (function() {
                    var em = document.createElement('script'); em.type = 'text/javascript'; em.async = true;
                    em.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'leadback.ru/js/leadback.js';
                    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(em, s);
                })();
            `}
        </Script>
    )
}
